function FormSelect() {
  this.init();
}

FormSelect.prototype.init = function() {
  $('.form-custom-select-wrapper').on('click', function(event) {
    $(this).toggleClass('active');
    event.stopPropagation();
  });

  $('.form-custom-select-wrapper a').on('click', function(event) {
    event.preventDefault();
    var $listEl = $(this).parent();
    var $container = $listEl.parent().parent();
    var $chosenEl = $container.find('.form-select-chosen');

    var selectedValue = $(this).data('option-id');
    $listEl.addClass('current');
    $listEl.siblings().removeClass('current');
    $chosenEl.text($(this).text());
    $chosenEl.attr('data-chosen', selectedValue);
  });

  // Use the selectize plugin for selects.
  $('.form-select-wrapper-atom').selectize();
};

module.exports = FormSelect;
